import { showModal } from './actions';

export const makeAction = (component) => {
  return (props) => showModal(component, props);
};
